import React, {PureComponent} from "react"

import OptionPicker, {Option} from "../../OptionPicker"
import SetBrand from "./SetBrand"
import {isDefaultBrand, resetBrand} from "../../../helpers"
import OptionContainerProps from "../sharedProps"
import BrandPreview, {PreviewVariants} from "./BrandPreview"

interface Props extends OptionContainerProps {}
class Brand extends PureComponent<Props> {
  optionData: Option[] = [
    {
      selectionId: 1,
      title: "setup_tenant.steps.brand.options.custom.title",
      description: "setup_tenant.steps.brand.options.custom.description",
      actionRequiredForStepCompletion: true,
      component: <SetBrand isDefaultBrand={isDefaultBrand} setIsStepCompletable={this.props.setIsStepCompletable} />
    },
    {
      selectionId: 2,
      title: "setup_tenant.steps.brand.options.usePerkbox.title",
      description: "setup_tenant.steps.brand.options.usePerkbox.description",
      actionRequiredForStepCompletion: false,
      component: <BrandPreview variant={PreviewVariants.Default} />
    }
  ]

  render() {
    const {existingSelectionId, handleOptionChange, setIsStepCompletable} = this.props
    return (
      <OptionPicker
        options={this.optionData}
        existingSelectionId={existingSelectionId}
        handleOptionChange={handleOptionChange}
        setIsStepCompletable={setIsStepCompletable}
        areStepSettingsDefault={isDefaultBrand}
        resetToDefault={resetBrand} />
    )
  }
}

export default Brand
